import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { scenarioIcons, scenarioSurface } from "@/constants/scenarioVisuals";

const CARD_INITIAL = { opacity: 0, y: 16 };
const CARD_ANIMATE = { opacity: 1, y: 0 };
const getCardTransition = (index) => ({ delay: index * 0.04, duration: 0.35 });

export default function ScenarioCard({ scenario, onStart, index = 0 }) {
  const Icon = scenarioIcons[scenario.id] || ArrowRight;
  const surface = scenarioSurface[scenario.id] || "surface-neutral";

  return (
    <motion.article
      initial={CARD_INITIAL}
      animate={CARD_ANIMATE}
      transition={getCardTransition(index)}
      className={`neo-card scenario-card ${surface}`}
      data-testid={`scenario-card-${scenario.id}`}
      data-testgroup="scenario-card"
    >
      <div className="scenario-image-wrap" data-testid={`scenario-image-wrap-${scenario.id}`}>
        <img src={scenario.image_url} alt="" className="scenario-image" data-testid={`scenario-image-${scenario.id}`} />
        <span className="scenario-icon" data-testid={`scenario-icon-${scenario.id}`}>
          <Icon size={26} strokeWidth={2.6} />
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex flex-wrap items-center gap-2">
          <span className="label-chip" data-testid={`scenario-category-${scenario.id}`}>{scenario.category}</span>
          <span className="label-chip bg-white" data-testid={`scenario-minutes-${scenario.id}`}>{scenario.minutes} min</span>
        </div>
        <h3 className="mt-4 font-display text-2xl font-black" data-testid={`scenario-title-${scenario.id}`}>{scenario.title}</h3>
        <p className="mt-2 text-sm font-semibold text-slate-600" data-testid={`scenario-description-${scenario.id}`}>{scenario.description_pt}</p>
        <div className="mt-4 flex flex-wrap gap-2" data-testid={`scenario-goals-${scenario.id}`}>
          {scenario.goals.slice(0, 3).map((goal) => (
            <span key={goal} className="goal-pill" data-testid={`scenario-goal-${scenario.id}-${goal.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{goal}</span>
          ))}
        </div>
        <button
          type="button"
          onClick={() => onStart(scenario.id)}
          className="primary-action mt-5"
          data-testid={`start-scenario-button-${scenario.id}`}
          data-testgroup="scenario-start-button"
        >
          Começar prática
          <ArrowRight size={19} strokeWidth={2.7} />
        </button>
      </div>
    </motion.article>
  );
}